import useFacets from './useFacets';
import { getFacetComponentName, getFacetComponent, getFacetUtil } from '../components/criteria/facetTypes';

export default function useFacetTypes() {
  const { customFacetTypes } = useFacets();

  const getFacetTypeComponentName = (facet) => getFacetComponentName(facet.name, facet.facetType, customFacetTypes.value);
  const getFacetTypeComponent = (facet) => getFacetComponent(facet.name, facet.facetType, customFacetTypes.value);
  const getFacetTypeUtil = (facet) => getFacetUtil(facet.name, facet.facetType, customFacetTypes.value);

  return {
    getFacetTypeComponentName,
    getFacetTypeComponent,
    getFacetTypeUtil,
  };
}
